import React, { useCallback } from "react";
import "./standardButton.css";
import { CircularProgress } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import * as motion from "motion/react-client";

export interface StandarButtonProps {
  onClick: (e: any) => void;
  buttonText: string;
  buttonColor?: string;
  customStyles?: React.CSSProperties;
  disabled?: boolean;
  isLoading?: boolean;
  isBack?: boolean;
  shepardClass?: string;
}

export const StandardButton = React.memo(
  ({
    onClick,
    buttonText,
    buttonColor,
    customStyles,
    disabled,
    isLoading,
    isBack,
    shepardClass
  }: StandarButtonProps) => {
    const style = { ...(buttonColor ? { backgroundColor: buttonColor } : {}) };
    const stopPropOnClick = useCallback(
      (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onClick(e);
      },
      [onClick]
    );

    let content;

    switch (true) {
      case isLoading:
        content = <CircularProgress />;
        break;
      case isBack:
        content = <KeyboardBackspaceIcon />;
        break;
      default:
        content = buttonText;
    }
    return (
      <motion.div
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className={"standardButton " + shepardClass}
        onClick={stopPropOnClick}
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          minWidth: "15rem",
          minHeight: "3rem",
          fontSize: "1.5rem",
          opacity: disabled ? 0.5 : 1,
          ...style,
          ...customStyles,
        }}
      ><div style={{placeContent: 'center'}}>{content}</div>
      </motion.div>
    );
  }
);
